"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "SourcesService", {
    enumerable: true,
    get: function() {
        return SourcesService;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _apphooksservice = require("~/services/app-hooks/app-hooks.service");
const _helpers = require("~/helpers");
const _populateMeta = require("~/helpers/populateMeta");
const _syncMigration = require("~/helpers/syncMigration");
const _models = require("~/models");
const _catchError = require("~/helpers/catchError");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _NocoSocket = /*#__PURE__*/ _interop_require_default(require("~/socket/NocoSocket"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let SourcesService = class SourcesService {
    async baseGetWithConfig(context, param) {
        const source = await _models.Source.get(context, param.sourceId);
        if (!source) {
            _catchError.NcError.get(context).sourceNotFound(param.sourceId);
        }
        source.config = await source.getSourceConfig();
        return source;
    }
    async baseUpdate(context, param) {
        var _baseBody_config;
        (0, _helpers.validatePayload)('swagger.json#/components/schemas/BaseReq', param.source);
        const oldSource = await _models.Source.get(context, param.sourceId);
        if (!oldSource) {
            _catchError.NcError.get(context).sourceNotFound(param.sourceId);
        }
        const baseBody = param.source;
        const source = await _models.Source.update(context, param.sourceId, _extends({}, baseBody, {
            type: (_baseBody_config = baseBody.config) == null ? void 0 : _baseBody_config.client,
            id: param.sourceId
        }));
        source.config = undefined;
        source.integration_config = undefined;
        const integration = await _models.Integration.get(context, source.fk_integration_id);
        this.appHooksService.emit(_nocodbsdk.AppEvents.SOURCE_UPDATE, {
            source,
            oldSource,
            req: param.req,
            integration,
            context
        });
        _NocoSocket.default.broadcastEvent(context, {
            event: _nocodbsdk.EventType.META_EVENT,
            payload: {
                action: 'source_update',
                payload: source
            }
        }, context.socket_id);
        return source;
    }
    async baseList(context, param) {
        const sources = await _models.Source.list(context, {
            baseId: param.baseId
        });
        return sources;
    }
    async baseDelete(context, param, ncMeta = _Noco.default.ncMeta) {
        try {
            const source = await _models.Source.get(context, param.sourceId, true, ncMeta);
            const integration = await _models.Integration.get(context, source.fk_integration_id);
            await source.delete(context, ncMeta);
            this.appHooksService.emit(_nocodbsdk.AppEvents.SOURCE_DELETE, {
                source: _extends({}, source, {
                    config: undefined
                }),
                req: param.req,
                integration: _extends({}, integration, {
                    config: undefined
                }),
                context
            });
        } catch (e) {
            _catchError.NcError.get(context).badRequest(e);
        }
        return true;
    }
    async baseSoftDelete(context, param, ncMeta = _Noco.default.ncMeta) {
        try {
            const source = await _models.Source.get(context, param.sourceId, false, ncMeta);
            await source.softDelete(context, ncMeta);
            source.config = undefined;
            source.integration_config = undefined;
            _NocoSocket.default.broadcastEvent(context, {
                event: _nocodbsdk.EventType.META_EVENT,
                payload: {
                    action: 'source_delete',
                    payload: source
                }
            }, context.socket_id);
        } catch (e) {
            _catchError.NcError.get(context).badRequest(e);
        }
        return true;
    }
    async baseCreate(context, param) {
        var _baseBody_alias, _baseBody_config_connection, _baseBody_config;
        (0, _helpers.validatePayload)('swagger.json#/components/schemas/BaseReq', param.source);
        // type | base | baseId
        const baseBody = param.source;
        baseBody.alias = (_baseBody_alias = baseBody.alias) == null ? void 0 : _baseBody_alias.trim();
        const base = await _models.Base.getWithInfo(context, param.baseId);
        let error;
        param.logger == null ? void 0 : param.logger.call(param, 'Creating the source');
        let integration;
        // if missing integration id, create a new private integration
        // and map the id to the source
        if (!baseBody.fk_integration_id) {
            var _baseBody_config1, _param_req_user, _param_req_user1, _baseBody_config2, _baseBody_config3;
            integration = await _models.Integration.createIntegration({
                title: baseBody.alias,
                type: _nocodbsdk.IntegrationsType.Database,
                sub_type: (_baseBody_config1 = baseBody.config) == null ? void 0 : _baseBody_config1.client,
                is_private: !!((_param_req_user = param.req.user) == null ? void 0 : _param_req_user.id),
                config: baseBody.config,
                workspaceId: context.workspace_id,
                created_by: (_param_req_user1 = param.req.user) == null ? void 0 : _param_req_user1.id
            });
            baseBody.fk_integration_id = integration.id;
            baseBody.config = {
                client: (_baseBody_config2 = baseBody.config) == null ? void 0 : _baseBody_config2.client
            };
            baseBody.type = (_baseBody_config3 = baseBody.config) == null ? void 0 : _baseBody_config3.client;
        } else {
            integration = await _models.Integration.get(context, baseBody.fk_integration_id);
            // Check if integration exists
            if (!integration) {
                _catchError.NcError.get(context).integrationNotFound(baseBody.fk_integration_id);
            }
            // check if integration is of type Database
            if (integration.type !== _nocodbsdk.IntegrationsType.Database || !integration.sub_type) {
                _catchError.NcError.badRequest('Integration type should be Database');
            }
            baseBody.type = integration.sub_type;
        }
        // update invalid ssl config value if found
        if ((_baseBody_config = baseBody.config) == null ? void 0 : (_baseBody_config_connection = _baseBody_config.connection) == null ? void 0 : _baseBody_config_connection.ssl) {
            baseBody.config.connection.ssl = (0, _nocodbsdk.validateAndExtractSSLProp)(baseBody.config.connection, baseBody.config.sslUse, baseBody.config.client);
        }
        const source = await _models.Source.createBase(context, _extends({}, baseBody, {
            baseId: base.id
        }));
        try {
            await (0, _syncMigration.syncBaseMigration)(base, source);
            param.logger == null ? void 0 : param.logger.call(param, 'Populating meta');
            const info = await (0, _helpers.populateMeta)(context, {
                source,
                base,
                logger: param.logger,
                user: param.req.user
            });
            await (0, _populateMeta.populateRollupColumnAndHideLTAR)(context, source, base);
            this.appHooksService.emit(_nocodbsdk.AppEvents.APIS_CREATED, {
                info,
                req: param.req,
                context
            });
            source.config = undefined;
            source.integration_config = undefined;
            this.appHooksService.emit(_nocodbsdk.AppEvents.SOURCE_CREATE, {
                source,
                req: param.req,
                integration,
                context
            });
            _NocoSocket.default.broadcastEvent(context, {
                event: _nocodbsdk.EventType.META_EVENT,
                payload: {
                    action: 'source_create',
                    payload: source
                }
            }, context.socket_id);
        } catch (e) {
            error = e;
        }
        return {
            source,
            error
        };
    }
    constructor(appHooksService){
        this.appHooksService = appHooksService;
    }
};
SourcesService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _apphooksservice.AppHooksService === "undefined" ? Object : _apphooksservice.AppHooksService
    ])
], SourcesService);
